import { call, put, select, takeLatest } from 'redux-saga/effects';

import { dataTableActionCreators, dataTableActionTypes } from '../dataTable';
import { filterActionTypes } from '../filter';
import { reportActionTypes } from '../report';
import selectors from '../selectors';

// WATCHERS
function* maybeFetch(action) {
    const { type } = action;
    const typesThatTriggerFetch = [
        dataTableActionTypes.SET_SORT,
        dataTableActionTypes.SET_PAGE_SIZE,
        dataTableActionTypes.SET_PAGE,
        reportActionTypes.SET_APPLIED_REPORT,
        filterActionTypes.SET_APPLIED_FILTERS,
        reportActionTypes.SET_REPORT_AND_FILTERS,
    ];

    if (typesThatTriggerFetch.includes(type)) {
        const deeplinkUrl = yield select(selectors.genDeeplinkUrl);
        yield call([window.history, 'replaceState'], {}, '', deeplinkUrl);
        yield put(dataTableActionCreators.requestData());
    }
}

function* watchFetchTriggers() {
    yield takeLatest('*', maybeFetch);
}

// EXPORT / OUTSIDE INTERFACE
export default {
    watchFetchTriggers: watchFetchTriggers(),
};
